/* xcloud-brand-overrides.js — 2026-04-25 (text-node TreeWalker, regression fix)
 *
 * Strips taxonomy prefixes (Style_, Color_, Material_, Size_, Brand_,
 * Firmness_, AgeGroup_, PieceType_, SeatCount_) from Xcloud filter value
 * labels so users see clean labels ("Casual" not "Style_Casual").
 *
 * Why TreeWalker over a class-name selector: Xcloud's rendered DOM puts the
 * value text directly inside <label> as a sibling text node of the input —
 * NOT inside a __text span. The 2026-04-25 first-pass JS used a class
 * selector and matched zero nodes. This version walks every text node under
 * the sidebar and replaces matching prefixes wherever they appear.
 *
 * Strategy: initial sweep on DOMContentLoaded; MutationObserver on the
 * sidebar root for re-renders; belt-and-suspenders timer sweeps for late-
 * mounted DOM. Idempotent — only mutates a text node when the cleaned
 * string differs from the source.
 */
(function () {
  var PREFIX_RE = /(Style|Color|Material|Size|Brand|Firmness|AgeGroup|Age Group|PieceType|Piece Type|SeatCount|Seat Count)_/g;

  function sweepTextNodes(root) {
    if (!root) return 0;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n, count = 0;
    while ((n = walker.nextNode())) {
      var t = n.nodeValue;
      if (!t || t.indexOf('_') === -1) continue;
      var cleaned = t.replace(PREFIX_RE, '');
      if (cleaned !== t) {
        n.nodeValue = cleaned;
        count++;
      }
    }
    return count;
  }

  function getPrimaryRoot() {
    return (
      document.querySelector('.cloud-search-filters-sidebar') ||
      document.querySelector('.cloud-search-filters-sidebar-container') ||
      document.getElementById('cloud_search_filters_sidebar') ||
      document.getElementById('cloud_search_filters_root')
    );
  }

  function sweep() {
    sweepTextNodes(getPrimaryRoot());
  }

  var observer = null;
  var rafId = null;
  function scheduleSweep() {
    if (rafId) return;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    rafId = raf(function () {
      rafId = null;
      sweep();
    });
  }

  function start() {
    sweep();
    var root = getPrimaryRoot();
    if (root && typeof MutationObserver !== 'undefined' && !observer) {
      observer = new MutationObserver(scheduleSweep);
      // childList + subtree captures Xcloud re-renders. Skip characterData
      // to avoid feedback loops with our own nodeValue writes.
      observer.observe(root, { childList: true, subtree: true });
    }
    setTimeout(sweep, 1500);
    setTimeout(sweep, 3000);
    setTimeout(sweep, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
